<template>
  <van-col style="width: 100%; background-color: #f7f7f7;">
    <div class="enterprise-title">
      <div class="enterprise-line"></div>
      <div class="enterprise-text">企业注册 </div>
    </div>
    <van-form @submit="onSubmit" style="margin-top: 20px;" :model="dataform">
      <van-field v-model="dataform.enterpriseName" label="企业名称" placeholder="请输入企业名称" :rules="[{ required: true }]" input-align="right" clearable/>
      <van-field v-model="dataform.enterpriseCode" label="企业纳税号" placeholder="请输入企业纳税号" :rules="[{ required: true }]" input-align="right" clearable/>
      <van-field v-model="dataform.name" label="负责人姓名" placeholder="请输入负责人姓名" :rules="[{ required: true }]" input-align="right" clearable/>
      <van-field v-model="dataform.identityCard" label="负责人身份证号" placeholder="请输入负责人身份证号" :rules="[{ required: true }]" input-align="right" clearable/>
      <van-field :value="sexValue" label="负责人性别" input-align="right" placeholder="请选择性别"  right-icon="arrow" :rules="[{ required: true }]" @click="onClickSex" readonly clearable/>
      <van-field v-model="dataform.account" label="负责人手机号" type="tel" placeholder="请输入手机号" maxlength="11" :rules="[{ required: true}]" input-align="right" clearable/>
      <div style="padding: 60px 16px;">
        <van-button round block type="info" native-type="submit">注册</van-button>
      </div>
    </van-form>

    <van-action-sheet v-model="showSexSheet" :actions="actions" @select="onSelect" />

  </van-col>
</template>

<script>

import request from "@/utils/request";
import { Toast } from 'vant';

export default {
  data() {
    return {
      sexValue: '',
      isCountFinish: true,
      showSexSheet: false,
      actions: [{ name: '男', id: 0 }, { name: '女', id: 1 }],
      dataform: {
        smallProgramOpenId: "",
        publicAccountOpenId: "",
        weChatUnionid: "",
        img: "",
        account: "",
        pwd: "",
        name: "",
        duty: 3,
        status: 4,
        identityCard: "",
        sex: "",
        departmentId: "",
        enterpriseName: "",
        enterpriseCode: "",
        salesmanId: "",
        remark: "",
      },
    };
  },

  methods: {
     onClickSex() {
      this.showSexSheet = true;
    },
     onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.showSexSheet = false;
      this.sexValue = item.name;
      this.dataform.sex = item.id;
    },
     onClickStatrCount() {
      this.$refs.countDown.reset();
      this.isCountFinish = false;
    },
    onClickCountFinish() {
      this.isCountFinish = true;
    },
      onSubmit() {
       const tempDataForm = Object.assign({}, this.dataform);
        request.post("/User/AccountMng/CreateEnterprise", tempDataForm).then(() => {
            Toast("注册成功");
            this.$router.replace({ name: 'home' });
        }).catch(() => {
        
        });
    },
  }
};
</script>

<style lang="less">
.enterprise-title {
  display: flex;
  background-color: #fff;
  padding: 12px;
  width: 100%;
  position: relative;
}

.enterprise-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.enterprise-text {
  position: absolute;
  left: 47.5%;
  transform: translateX(-50%);
  color: #333;
  font-size: 18px;
  font-weight: 500;
}

.enterprise-content {
  padding-right: 20px;
  text-align: right;
  color: #333;
  border: none;
  width: 95%;
}

</style>
